var menu = $('.footer.policy-popup li, .footer.policy-popup .company');
var body = $('.policy-popup-wrap');

menu.click(function(){
  $('body').addClass('popOpen');
  $('.policy-popup-overlay').addClass('active');
  
  var name = $(this).attr("class");
  body.each(function(){
    var data = $(this).attr('data-type');
    if(name == data){
      $(this).addClass('active');
    }
  })
});

var product = $('.template-product .product-content .popup > div');
product.click(function(){
  $('body').addClass('popOpen');
  $('.policy-popup-overlay').addClass('active');
  
  var name = $(this).attr("class");
  body.each(function(){
    var data = $(this).attr('data-type');
    if(name == data){
      $(this).addClass('active');
    }
  })
})

body.find('.close').click(function(){
  $('body').removeClass('popOpen');
  $('.policy-popup-overlay').removeClass('active');
  body.removeClass('active');
})

$('.policy-popup-overlay').click(function(){
  $('body').removeClass('popOpen');
  $(this).removeClass('active');
  body.removeClass('active');
})

$(window).scroll(function(){
  var scrT = $(window).scrollTop();
  var footH =   $('#shopify-section-footer').height();
  var height = $(document).height() - $(window).height() - footH*2
  if(scrT > height ){
  	$('.custom-app-section .site-box-container').addClass('absolute');
    $('.template-article .site-box-content .back_btn a').addClass('absolute');
  } else {
  	$('.custom-app-section .site-box-container').removeClass('absolute');
    $('.template-article .site-box-content .back_btn a').removeClass('absolute');
  }
})

